// imports
import {Utility} from "./core/utility"
import {Features} from "./core/api"
import {router} from "./core/router"
import {StateCore} from "./core/state"
import {Breadcrumbs} from "./core/breadcrumbs";
import {SFV_Support} from "./support/singleFileView";

/**
 * A list of custom animations provided by ActiveJS
 * @type {{Zoom: Animations.Zoom, Fade: Animations.Fade}}
 */
export const Animations = {

    /**
     * Animation type for routing
     * @type {String}
     */
    TYPE_SLIDE_OVER: "SLIDE_OVER",

    /**
     * Will fade in an element
     * @param {Element} Element
     * @param {Object} Options
     * @constructor
     */
    Fade: (Element, Options) => {
        Element.animate([
            {opacity: 0},
            {opacity: 1}
        ], {
            duration: (Options.duration)? Options.duration : 500,
            easing: (Options.easing)? Options.easing : 'ease-in',
            fill: "forwards"
        });
    },

    /**
     * Will zoom in an element
     * @param {Element} Element
     * @param {Object} Options
     * @constructor
     */
    Zoom: (Element, Options) => {
        // animation
        Element.animate([
            {
                transform: `translateX(${(Options.x !== undefined)?Options.x:'0'}) translateY(${(Options.y !== undefined)?Options.y:'500px'})`,
            },{
                transform: `translateX(0) translateY(0)`,
            },
        ], {
            // timing options
            duration: (Options.duration !== undefined)?Options.duration : 1000,
            easing: (Options.easing !== undefined)?Options.easing : 'ease-in-out',
            iterations: 1,
            fill: "forwards"
        });
    },
};

/**
 * The entry point of you ActiveJS application
 * @param {{renderEl: String, routes: Array, visualErrors: Boolean}} configuration
 * @param {Function} Created
 * @returns {*}
 */
export const createApp = (configuration, Created) => {

    // parse the options
    if (Utility.validateAppOptions(configuration)) {
        // setup new APIs
        Features.setup();

        //* setup the ActiveJS data used for the framework
        Utility.setEnvironment(configuration);

        //* initialize the router
        router.generateRouter(configuration.routes);

        //* load app styles
        Utility.loadAppStyles();

        // log app info
        Utility.logAppInfo();

        //* wait for the custom init process to finnish
        if (Created) document.addEventListener("DOMContentLoaded", () => Created(), false);
    }
    else {
        // throw error
    }

};

/**
 * Will load a library into ActiveJS for use inside of views
 * @param {String} key
 * @param {Object} object
 * @constructor
 */
export const Load = (key, object) => {
    $ActiveJS['Libraries'][key] = object;
};

/**
 * Allows you to save data in memory
 * @type {{createStore: (function(*): {Commit: function(*=, *=): (*|undefined), Get: function(): *, Select: function(*=, *, *=): *})}}
 */
export const State = {
    createStore: StateCore.CreateStore
};

/**
 * ActiveJS Router Class
 * @type {{
 *      route: (path: any, params: any) => void,
 *      navBack: () => void,
 *      useUrl: () => void,
 *      isBaseURL: () => Boolean,
 *      getHistory: () => [],
 *      beforeEach: (callback: Function) => void,
 * }}
 */
export  const Router = {
    route: router.search,
    navBack: router.navBack,
    useUrl: router.getCurrentURL,
    isBaseURL: Utility.isBaseURL,
    getHistory: Breadcrumbs.getAll,
    beforeEach: router.setupBeforeEach
};

/**
 * Defines a reactive property on the controller
 * @param {Object} value
 * @returns {{value: *, isDef: Boolean}}
 */
export const Def = Features.Def;

/**
 * Defines a reactive object on the controller
 * @param {Object} value
 * @returns {Object}
 */
export const Reactive = Features.Reactive;

/**
 * todo : implement
 * Allows for watching a reactive properties for change
 * @param {String} property
 * @param {Function} callback
 */
export const Observe = Features.Observe;

/**
 * Life cycle method which is called when the controller in mounted to the view
 * @param {Function} callback
 * @constructor
 */
export const onMounted = Features.onMounted;

/**
 * Life cycle method which is called when the view template has been rendered
 * @param {Function} callback
 * @constructor
 */
export const onRendered = Features.onRendered;

/**
 * Life cycle method which is called when you route to another view
 * @param {Function} callback
 * @constructor
 */
export const onDestroyed = Features.onDestroyed;

/**
 * Gets the value of a prop passed to a view/component
 * @param {String} name
 * @constructor
 */
export const Prop = Features.Prop;

/*
 * Will define a default 404 page for the application
 * @param url
 */
export const pageNotFound = Features.pageNotFound;

/**
 * Support for the old framework
 * @param name
 * @param controller
 */
export const newController = SFV_Support.newController;